var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card p-20"},[_c('div',{staticClass:"flex align-center bb py-10"},[_c('h2',{staticClass:"fs-20 bold flex-1"},[_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n\t\t")]),_vm._t("navigation")],2),_vm._t("body")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }